import { UrlUtils } from '@atlassian/mpac-utils';
import { Record } from 'immutable';
export const defaultVendorType = 'thirdParty';

// This type definition of partner-details api is based on new partner-user API

/* App details published by a Partner  */

export const makeVendor = Record({
  id: 0,
  name: null,
  link: null,
  vendorType: defaultVendorType,
  topVendorStatus: undefined
});
export const makeVendorFromMarketplaceApp = _ref => {
  var _marketplaceApp$_embe, _vendor$_links$altern, _vendor$_links$self$h, _vendor$_links$self, _marketplaceApp$_embe2, _marketplaceApp$_embe3, _marketplaceApp$_embe4, _marketplaceApp$_embe5, _marketplaceApp$_embe6, _marketplaceApp$_embe7;
  let {
    marketplaceApp,
    mpacBaseUrl
  } = _ref;
  const vendor = (_marketplaceApp$_embe = marketplaceApp._embedded) === null || _marketplaceApp$_embe === void 0 ? void 0 : _marketplaceApp$_embe.vendor;
  const vendorLink = vendor === null || vendor === void 0 ? void 0 : (_vendor$_links$altern = vendor._links.alternate) === null || _vendor$_links$altern === void 0 ? void 0 : _vendor$_links$altern.href;
  const id = (_vendor$_links$self$h = vendor === null || vendor === void 0 ? void 0 : (_vendor$_links$self = vendor._links.self) === null || _vendor$_links$self === void 0 ? void 0 : _vendor$_links$self.href.split('/').pop()) !== null && _vendor$_links$self$h !== void 0 ? _vendor$_links$self$h : '0';
  return makeVendor({
    id: Number.parseInt(id, 10),
    name: vendor === null || vendor === void 0 ? void 0 : vendor.name,
    link: vendorLink ? UrlUtils.validateSafeAbsoluteUrl(mpacBaseUrl + vendorLink) : null,
    vendorType: (_marketplaceApp$_embe2 = marketplaceApp._embedded) !== null && _marketplaceApp$_embe2 !== void 0 && (_marketplaceApp$_embe3 = _marketplaceApp$_embe2.vendor) !== null && _marketplaceApp$_embe3 !== void 0 && _marketplaceApp$_embe3.isAtlassian ? 'internal' : 'thirdParty',
    topVendorStatus: (_marketplaceApp$_embe4 = marketplaceApp._embedded) === null || _marketplaceApp$_embe4 === void 0 ? void 0 : (_marketplaceApp$_embe5 = _marketplaceApp$_embe4.vendor) === null || _marketplaceApp$_embe5 === void 0 ? void 0 : (_marketplaceApp$_embe6 = _marketplaceApp$_embe5.programs) === null || _marketplaceApp$_embe6 === void 0 ? void 0 : (_marketplaceApp$_embe7 = _marketplaceApp$_embe6.topVendor) === null || _marketplaceApp$_embe7 === void 0 ? void 0 : _marketplaceApp$_embe7.status
  });
};